<template lang="pug">

  article.sponsoritem
    .col
      .video
        .iframewrapper(v-html="post.content.rendered")
    .col
      h2(v-html="post.title.rendered")
      .excerpt(v-html="post.excerpt.rendered")


</template>
<script>
export default {
  props: {
    post: Object,
    position: String
  },
}
</script>
<style lang="scss" scoped>
  .sponsoritem{
    position: relative;
    display: grid;
    grid-template-columns: 3fr 2fr;
    align-items: center;
    grid-gap: $globalgapping;
    margin-bottom: 1rem;
    padding: $globalpadding;
    color: white;
    @media (max-width: 800px){
      grid-template-columns: 1fr;
    }
  }
  .iframewrapper{
    position: relative;
    padding-top: 56.25%;
    padding-bottom: 0;
    height: 0;
    width: 100%;
    /deep/ iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

</style>

